import { render, staticRenderFns } from "./SupportList.vue?vue&type=template&id=a1b71f5a&scoped=true&lang=pug"
import script from "./SupportList.vue?vue&type=script&lang=ts"
export * from "./SupportList.vue?vue&type=script&lang=ts"
import style0 from "./SupportList.vue?vue&type=style&index=0&id=a1b71f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b71f5a",
  null
  
)

export default component.exports